import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FormInputState } from 'src_common/common/mobx-utils/Form2/FormInputState';
import { InputWrapper, StyledInput, ErrorIcon, ErrorTooltip } from './InputField.style';
import { InfoErrorIcon } from 'src/assets/icons/InfoErrorIcon';

interface InputFieldPropsType {
    formInputState: FormInputState<string, unknown>;
    disabled?: boolean;
    originalValue?: string;
    placeholder?: string;
    autoFocus?: boolean;
    name?: string;
    autoComplete?: string;
    allowedPattern?: RegExp;
    inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
}

export const InputField = observer(
    ({
        formInputState,
        disabled = false,
        originalValue,
        placeholder,
        autoFocus,
        name,
        autoComplete,
        allowedPattern,
        inputMode,
    }: InputFieldPropsType): JSX.Element => {
        const [showTooltip, setShowTooltip] = useState(false);
        const errors = formInputState.errorsForView;
        const error = errors.length === 0 ? null : (errors[0] ?? null);
        const hasError = error !== null;
        const isModified = originalValue !== undefined && formInputState.value !== originalValue;

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
            const nextValue = event.target.value;

            if (allowedPattern !== undefined && nextValue !== '' && !allowedPattern.test(nextValue)) {
                return;
            }

            formInputState.setValue(nextValue);
        };

        return (
            <InputWrapper>
                <StyledInput
                    value={formInputState.value}
                    onChange={handleChange}
                    onBlur={formInputState.setAsVisited}
                    hasError={hasError}
                    isModified={isModified}
                    disabled={disabled}
                    type='text'
                    inputMode={inputMode}
                    placeholder={placeholder}
                    autoFocus={autoFocus}
                    name={name}
                    autoComplete={autoComplete}
                />
                {hasError && (
                    <ErrorIcon
                        onMouseEnter={(): void => setShowTooltip(true)}
                        onMouseLeave={(): void => setShowTooltip(false)}
                    >
                        <InfoErrorIcon />
                        <ErrorTooltip show={showTooltip}>{error}</ErrorTooltip>
                    </ErrorIcon>
                )}
            </InputWrapper>
        );
    }
);
